import { Component, EventEmitter, Input, OnDestroy, Output, signal } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';

import { Filter, IOption } from '../filters';

@Component({
  selector: 'cbre-abstract-filter',
  template: '',
  standalone: false,
})
export abstract class AbstractFilterComponent implements OnDestroy {
  @Input() set form(value: FormGroup) {
    this._form = value;
    this._setUpFilter();
  }

  @Input() set filter(filter: Filter) {
    this.filter$.set(filter);
    this._setUpFilter();
  }

  @Input() showLabel = true;

  @Output() public removeFilter = new EventEmitter();

  public readonly filter$ = signal<Filter>(null);
  public control: FormControl;
  public options: IOption[] = [];
  public hasClearIcon = false;

  protected _form: FormGroup;
  protected _destroy$ = new Subject();

  protected abstract _setUpFilter(): void;
  public abstract handleChange(nextValue: any): void;

  protected _checkValuePresence = () => {
    this.hasClearIcon = !!this.control?.value;
  };

  ngOnDestroy() {
    this._destroy$.next(true);
  }
}
